import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

interface LoadingScreenProps {
  message?: string;
  fullscreen?: boolean;
}

export default function LoadingScreen({ message = 'Loading...', fullscreen = true }: LoadingScreenProps): React.JSX.Element {
  const content = (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="flex flex-col items-center justify-center gap-4"
    >
      <div className="relative">
        <img src="/favicon.ico" alt="EcoleMinds" className="w-12 h-12 rounded-2xl animate-pulse" />
        <div className="absolute inset-0 rounded-2xl border-2 border-amber-500/30 animate-ping" />
      </div>
      <p className="text-sm font-medium text-slate-500">{message}</p>
    </motion.div>
  );

  if (fullscreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50/50">
        {content}
      </div>
    );
  }

  return <div className="py-16">{content}</div>;
}

export function InlineLoader({ message = 'Loading...' }: { message?: string }): React.JSX.Element {
  return (
    <div className="flex items-center justify-center gap-2 py-8">
      <Loader2 className="w-5 h-5 text-amber-500 animate-spin" />
      <span className="text-sm text-slate-500">{message}</span>
    </div>
  );
}
